import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ComplianceState } from 'src/app/compliance/store/state/compliance.state';

export const metadataConfigurationFeature = createFeatureSelector<ComplianceState>('compliance');

export const selectMetadataConfiguration = createSelector(
    metadataConfigurationFeature,
    (state) => state?.metadataConfiguration
);

export const selectAcceptanceIdentifiers = createSelector(
    metadataConfigurationFeature,
    (state) => state?.metadataConfiguration?.acceptanceIdentifiers
);

export const selectExpirationDateConfiguration = createSelector(
    metadataConfigurationFeature,
    (state) => state?.metadataConfiguration?.expirationDateConfiguration
);
